import { Tag } from '@dixa/lib-shared-habla';
import { createElement } from 'react';
import { renderToString } from 'react-dom/server';

import styles from '../../tokenInput.module.scss';

export function getTokenString(dataToken: string, label: string): string {
  return renderToString(
    createElement(
      Tag,
      {
        className: styles.tag,
        // @TODO [TEAMS-6383]
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        contentEditable: false,
        'data-token': dataToken,
      },
      label,
    ),
  );
}
